module.exports = __webpack_public_path__ + "img/scene4-4.12ff8c74.jpg";